import React, {FC} from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import {CTA, styled} from '@volkswagen-onehub/components-core';
import {WrapContentCenter} from './ContentWrapperStyled';
import TypographyHeading from './Typography/TypographyHeading';
import TypographyBody from './Typography/TypographyBody';

interface Props {
  onCancel?: () => void;
  onConfirm?: () => void;
  open?: boolean;
}

const DialogContent = styled(Dialog.Content)`
  padding: 40px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  background-color: white;
  border-radius: 8px;
  max-width: 400px;
  width: 80%;

  @media (max-width: 600px) {
    width: 60%;
  }
`;
const QuestionCloseDialog: FC<Props> = (props) => {
  const {onCancel, open, onConfirm} = props;
  return (
    <Dialog.Root open={open} modal>
      <Dialog.Portal>
        <Dialog.Overlay
          style={{
            position: 'absolute',
            top: 0,
            zIndex: 90,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            width: '100%',
            height: '100%',
          }}
        />
        <DialogContent>
          <TypographyHeading color="#000" textAlign="center" size="xMedium">
            Are you sure?
          </TypographyHeading>
          <div
            style={{
              marginTop: 24,
            }}
          >
            <TypographyBody
              textAlign="center"
              color="#000"
              size="body"
              style={{fontWeight: 400, lineHeight: '30px'}}
            >
              Closing eVW Fit will not save your progress. It will only take a
              couple of minutes to complete.
            </TypographyBody>
          </div>

          <WrapContentCenter style={{gap: 24, marginTop: 24}}>
            <CTA
              tag="button"
              emphasis="primary"
              onClick={onConfirm}
              ariaLabel="aria label"
            >
              <TypographyBody size="body">Yes, please close</TypographyBody>
            </CTA>
            <CTA
              tag="button"
              emphasis="tertiary"
              onClick={onCancel}
              ariaLabel="aria label"
            >
              <TypographyBody color="#001E50" size="body">
                Cancel
              </TypographyBody>
            </CTA>
          </WrapContentCenter>
        </DialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default QuestionCloseDialog;
